<template>
  <nav class="navbar sticky-top navbar-expand-lg d-none d-lg-flex" id="catalog-nav">
    <div class="container-fluid justify-content-end">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
        <div class="navbar-nav">
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#premium">
              {{ $t("catalog.premium") }}
            </router-link>
          </div>
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#dyed">
              {{ $t("catalog.dyed") }}
            </router-link>
          </div>
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#group">
              {{ $t("catalog.group") }}
            </router-link>
          </div>
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#garden">
              {{ $t("catalog.garden") }}
            </router-link>
          </div>
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#perpetual">
              {{ $t("catalog.perpetual") }}
            </router-link>
          </div>
          <div class="btn nav-item my-2 my-lg-0">
            <router-link class="nav-link px-3 py-2 mx-4" to="/catalog#other">
              {{ $t("catalog.other") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "CatalogHeaderComponent",
};
</script>

<style>
.btn.catalog-header {
  color: #535353 !important;
  border-radius: 29px !important;
  border: none !important;
  box-shadow: 4px 4px 4px #c9c1bd, -4px -4px 4px rgba(255, 255, 255, 0.4) !important;
}

#catalog-nav {
  margin-bottom: 3em !important;
  padding-top: 1em;
  padding-bottom: 2em;
  top: 7em !important;
}

.nav-item:focus {
  border-radius: 29px;
  border: none;
}
</style>
